// Lazy load видео и картинок goals
import goalsDesktopWebm from '../img/goals/goals_desktop_optimized.webm';
import goalsDesktopMp4 from '../img/goals/goals_desktop_optimized.mp4';
import goalsMobileWebm from '../img/goals/goals_mobile_optimized.webm';
import goalsMobileMp4 from '../img/goals/goals_mobile_optimized.mp4';
import goalsDesktopImg from '../img/goals/goals.webp';
import goalsMobileImg from '../img/goals/goals-mobile.webp';

export function initGoalsLazyLoad() {
  document.addEventListener('DOMContentLoaded', function () {
    let fullImg = document.querySelector('.goals__img-full');
    if (fullImg) {
      fullImg.addEventListener('load', function () {
        fullImg.classList.add('loaded');
      });
    }
    let video = document.querySelector('.goals__video');
    let posterImg = document.querySelector('.goals__poster-fallback img');
    if (video && posterImg) {
      let isDesktop = window.innerWidth >= 768;
      let webm = isDesktop ? goalsDesktopWebm : goalsMobileWebm;
      let mp4 = isDesktop ? goalsDesktopMp4 : goalsMobileMp4;
      let poster = isDesktop ? goalsDesktopImg : goalsMobileImg;
      video.innerHTML = '<source src="' + webm + '" type="video/webm" /><source src="' + mp4 + '" type="video/mp4" />';
      video.setAttribute('poster', poster);
      video.style.display = 'block';
      posterImg.src = poster;
      posterImg.style.display = 'none';
      video.load();

      const observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              video.play();
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0 }
      );
      observer.observe(video);
    }
  });
}
